import React from 'react';
import { Box, Typography, Alert } from '@mui/material';
import { TrafficLightSelector } from '../../utilComponents/inputs/TrafficLightSelector';
import { CustomDateInput } from '../../utilComponents/inputs/CustomDateInput';
import { validateInput } from '../../../helpers/validateInput';

export const TrafficLightFormStep = ({ form, handleUpdateForm }) => {
	const areAllTrafficLightsEmpty = () => {
		return (
			!form.trafficLightContact &&
			!form.trafficLightAppointment &&
			!form.trafficLightLead &&
			!form.trafficLightQuote &&
			!form.trafficLightClosing
		);
	};

	return (
		<Box mb={4}>
			<Typography variant='h6' sx={{ marginBottom: '10px' }}>
				Paso 2: Semáforos
			</Typography>
			<Alert severity='info' sx={{ marginBottom: '20px' }}>
				El semáforo te permite indicar el estado actual de los eventos
				(verde: positivo, rojo: negativo, amarillo: pendiente). Al
				seleccionar el estado de un semáforo, aparecerá un campo donde
				podrás asignar una fecha correspondiente al evento. Esto te
				ayudará a llevar un seguimiento más preciso del progreso.
			</Alert>

			{areAllTrafficLightsEmpty() && (
				<Box sx={{ flex: '1 1 23%', mb: 2 }}>
					<Alert
						severity='warning'
						sx={{
							display: 'flex',
							alignItems: 'center',
							height: '56px',
							boxSizing: 'border-box',
						}}
					>
						El campo para la selección de fecha se mostrará cuando
						se seleccione un color de semáforo.
					</Alert>
				</Box>
			)}

			<div
				style={{
					display: 'grid',
					gridTemplateColumns: '1fr 1fr',
					gap: '20px',
				}}
			>
				<div style={{ display: 'flex', flexDirection: 'column' }}>
					<Typography variant='body1' sx={{ marginBottom: '8px' }}>
						Estado del Contacto
					</Typography>
					<TrafficLightSelector
						label='Semáforo'
						value={form.trafficLightContact}
						onChange={(e) =>
							handleUpdateForm(
								'trafficLightContact',
								e.target.value
							)
						}
						options={[
							{ value: 'GRN', label: 'Verde' },
							{ value: 'YLW', label: 'Amarillo' },
							{ value: 'RED', label: 'Rojo' },
							{ value: 'NUL', label: '---' },
						]}
					/>
				</div>

				{form.trafficLightContact ? (
					<div style={{ display: 'flex', flexDirection: 'column' }}>
						<Typography
							variant='body1'
							sx={{ marginBottom: '8px' }}
						>
							Fecha de Contacto
						</Typography>
						<CustomDateInput
							label='Fecha'
							value={form.date1}
							onChange={(date) => {
								console.log('date 1', date);
								handleUpdateForm('date1', date);
							}}
							error={!!validateInput('date1', form.date1, form)}
							helperText={validateInput(
								'date1',
								form.date1,
								form
							)}
						/>
					</div>
				) : (
					<div />
				)}

				<div style={{ display: 'flex', flexDirection: 'column' }}>
					<Typography variant='body1' sx={{ marginBottom: '8px' }}>
						Estado de la Cita
					</Typography>
					<TrafficLightSelector
						label='Semáforo'
						value={form.trafficLightAppointment}
						onChange={(e) =>
							handleUpdateForm(
								'trafficLightAppointment',
								e.target.value
							)
						}
						options={[
							{ value: 'GRN', label: 'Verde' },
							{ value: 'YLW', label: 'Amarillo' },
							{ value: 'RED', label: 'Rojo' },
							{ value: 'NUL', label: '---' },
						]}
					/>
				</div>

				{form.trafficLightAppointment ? (
					<div style={{ display: 'flex', flexDirection: 'column' }}>
						<Typography
							variant='body1'
							sx={{ marginBottom: '8px' }}
						>
							Fecha de Cita
						</Typography>
						<CustomDateInput
							label='Fecha'
							value={form.date2}
							onChange={(date) => handleUpdateForm('date2', date)}
							error={!!validateInput('date2', form.date2, form)}
							helperText={validateInput(
								'date2',
								form.date2,
								form
							)}
						/>
					</div>
				) : (
					<div />
				)}

				<div style={{ display: 'flex', flexDirection: 'column' }}>
					<Typography variant='body1' sx={{ marginBottom: '8px' }}>
						Estado del Lead
					</Typography>
					<TrafficLightSelector
						label='Semáforo'
						value={form.trafficLightLead}
						onChange={(e) =>
							handleUpdateForm('trafficLightLead', e.target.value)
						}
						options={[
							{ value: 'GRN', label: 'Verde' },
							{ value: 'YLW', label: 'Amarillo' },
							{ value: 'RED', label: 'Rojo' },
							{ value: 'NUL', label: '---' },
						]}
					/>
				</div>

				{form.trafficLightLead ? (
					<div style={{ display: 'flex', flexDirection: 'column' }}>
						<Typography
							variant='body1'
							sx={{ marginBottom: '8px' }}
						>
							Fecha Lead
						</Typography>
						<CustomDateInput
							label='Fecha'
							value={form.date3}
							onChange={(date) => handleUpdateForm('date3', date)}
							error={!!validateInput('date3', form.date3, form)}
							helperText={validateInput(
								'date3',
								form.date3,
								form
							)}
						/>
					</div>
				) : (
					<div />
				)}

				<div style={{ display: 'flex', flexDirection: 'column' }}>
					<Typography variant='body1' sx={{ marginBottom: '8px' }}>
						Estado de la Cotización
					</Typography>
					<TrafficLightSelector
						label='Semáforo'
						value={form.trafficLightQuote}
						onChange={(e) =>
							handleUpdateForm(
								'trafficLightQuote',
								e.target.value
							)
						}
						options={[
							{ value: 'GRN', label: 'Verde' },
							{ value: 'YLW', label: 'Amarillo' },
							{ value: 'RED', label: 'Rojo' },
							{ value: 'NUL', label: '---' },
						]}
					/>
				</div>

				{form.trafficLightQuote ? (
					<div style={{ display: 'flex', flexDirection: 'column' }}>
						<Typography
							variant='body1'
							sx={{ marginBottom: '8px' }}
						>
							Fecha Cotización
						</Typography>
						<CustomDateInput
							label='Fecha'
							value={form.date4}
							onChange={(date) => handleUpdateForm('date4', date)}
							error={!!validateInput('date4', form.date4, form)}
							helperText={validateInput(
								'date4',
								form.date4,
								form
							)}
						/>
					</div>
				) : (
					<div />
				)}

				<div style={{ display: 'flex', flexDirection: 'column' }}>
					<Typography variant='body1' sx={{ marginBottom: '8px' }}>
						Estado del Cierre
					</Typography>
					<TrafficLightSelector
						label='Semáforo'
						value={form.trafficLightClosing}
						onChange={(e) =>
							handleUpdateForm(
								'trafficLightClosing',
								e.target.value
							)
						}
						options={[
							{ value: 'GRN', label: 'Verde' },
							{ value: 'YLW', label: 'Amarillo' },
							{ value: 'RED', label: 'Rojo' },
							{ value: 'NUL', label: '---' },
						]}
					/>
				</div>

				{form.trafficLightClosing ? (
					<div style={{ display: 'flex', flexDirection: 'column' }}>
						<Typography
							variant='body1'
							sx={{ marginBottom: '8px' }}
						>
							Fecha de Cierre
						</Typography>
						<CustomDateInput
							label='Fecha'
							value={form.date5}
							onChange={(date) => handleUpdateForm('date5', date)}
							error={!!validateInput('date5', form.date5, form)}
							helperText={validateInput(
								'date5',
								form.date5,
								form
							)}
						/>
					</div>
				) : (
					<div />
				)}
			</div>
		</Box>
	);
};
